import base from '../dr-base'
import drContentItem from './dr-content-item.vue'
import drBaseActions from '../dr-base-actions'

const schema = {
  $Type: 'dr-content-item',
  name: 'Content Item',
  group: 'Container widgets',
  icon: 'square',
  ...base,
  properties: {
    ...base.properties,
    Title: {
      name: 'vuetifyWidgets.dr-content-item.title',
      type: 'string'
    },
    SubTitle: {
      name: 'vuetifyWidgets.dr-content-item.subtitle',
      type: 'string'
    },
    BackgroundImg: {
      name: 'vuetifyWidgets.dr-content-item.backgroundImg',
      type: 'string'
    },
    Widgets: {
      type: 'array'
    },
    OnClickAction: {
      name: 'vuetifyWidgets.dr-content-item.onClickAction',
      type: 'object',
      component: 'dr-prop-action',
      properties: { ...drBaseActions.properties.OnClickAction.properties }
    }
  }
}

export default {
  schema,
  component: drContentItem
}
